import { BulkListingSearchFilter } from "./interfaces/bulk-listing-search-filter";
import { subtractUnits } from "./subtract-units";

export function whenToSearchFilter(when: string): Partial<BulkListingSearchFilter>[] {
	if (typeof when !== "string") {
		when = "30:days::0:days";
	}
	const [startExpression, endExpression] = when.split("::");
	let startDate: string;
	let endDate: string;
	if (startExpression.charAt(startExpression.length - 1) === "Z") {
		startDate = startExpression;
	} else {
		const [startNum, startUnit] = startExpression.split(":");
		startDate = subtractUnits(startNum, startUnit as any).toISOString();
	}
	if (endExpression.charAt(endExpression.length - 1) === "Z") {
		endDate = endExpression;
	} else {
		const [endNum, endUnit] = endExpression.split(":");
		endDate = subtractUnits(endNum, endUnit as any).toISOString();
	}
	return [
		{
			value: startDate,
			type: "StartDate",
		},
		{
			value: endDate,
			type: "EndDate",
		},
	];
}
